module.exports = __webpack_public_path__ + "static/media/ArrowLeft.67ac2236.svg";